import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=1c72ddb5&"
import script from "./tabPane.vue?vue&type=script&lang=js&"
export * from "./tabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports